import {css} from 'lit'; export default css`label{display:flex;flex-flow:column nowrap;padding-bottom:6px;font-size:14px;line-height:1.2;font-style:normal;font-weight:400;line-height:14px}`;
    